import { useTranslation } from 'react-i18next';

export default function LocationHero() {
  const { t } = useTranslation();

  return (
    <section className="relative pt-24 pb-16 md:pt-32 md:pb-20 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Colombian%20food%20truck%20parked%20urban%20street%20Boise%20Idaho%20night%20scene%20warm%20orange%20neon%20lights%20city%20street%20dramatic%20moody%20atmosphere%20dark%20background%20Latin%20American%20street%20food%20culture%20vibrant%20energy%20cinematic%20wide%20shot%20premium%20photography&width=1600&height=700&seq=lhero1&orientation=landscape"
          alt="Bucara Burger location Boise Idaho"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/95"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/60"></div>
      </div>

      {/* Bottom accent line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#F57F25]/50 to-transparent"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-[#F57F25]/15 border border-[#F57F25]/30 text-[#F57F25] text-xs font-bold px-4 py-2 rounded-full uppercase tracking-widest mb-6">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-map-pin-line text-xs"></i>
          </div>
          {t('location_page_badge')}
        </div>

        <h1 className="text-5xl md:text-7xl font-black text-white uppercase tracking-tight leading-none mb-5">
          {t('location_page_title')} <span className="text-[#F57F25]">{t('location_page_title_accent')}</span>
        </h1>

        <p className="text-white/65 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
          {t('location_page_sub')}
        </p>

        {/* Quick address pill */}
        <div className="mt-8 inline-flex items-center gap-2 bg-white/5 border border-white/10 text-white/70 text-sm px-5 py-2.5 rounded-full">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-map-pin-2-line text-[#F57F25] text-sm"></i>
          </div>
          1630 Broadway Ave, Boise, Idaho 83706
        </div>

        {/* Scroll indicator */}
        <div className="mt-10 flex justify-center">
          <div className="w-px h-12 bg-gradient-to-b from-[#F57F25] to-transparent"></div>
        </div>
      </div>
    </section>
  );
}
